/**
 * @param {{ canView: boolean, context: 'ringing' | 'queuedWhileActive' }} params
 */
export default function shouldDismissUnauthorizedIncoming({ canView, context }) {
  return context === 'ringing' && !canView;
}
